import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    
    // Check if we have both token and admin data
    const token = this.authService.getToken();
    const admin = this.authService.getCurrentAdmin();
    
    if (token && admin) {
      console.log('Auth guard: Access granted for admin:', admin.email);
      return true;
    }

    console.log('Auth guard: Access denied - redirecting to login');
    // Store the attempted URL for redirecting after login
    this.router.navigate(['/auth/login'], { 
      queryParams: { returnUrl: state.url }
    });
    
    return false;
  }
} 